module.exports = __webpack_public_path__ + "img/ski_cos5.9db8bd14.png";